// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".mp-tag-input-container{background-color:var(--background-color);border-color:var(--component-outline-color)}.mp-tag-input-container:hover{border-color:var(--component-outline-color)}.mp-tag-input-container:focus-within{border-color:var(--blue1)}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
